import * as React from 'react';

/**
 * @deprecated legacy hook. Now we have useApiMutation which is backed by react-query
 * and is more powerful.
 */
// @ts-expect-error - TS2370 - A rest parameter must be of an array type.
export function useAsyncAction<A>(action: (...args: A) => unknown): {
  isLoading: boolean;
  // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
  act: (...args: A) => Promise<void>;
} {
  const [isLoading, setIsLoading] = React.useState(false);

  return {
    isLoading,
    // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
    act: async (...args) => {
      if (!isLoading) {
        setIsLoading(true);
        try {
          // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'A'. | TS2488 - Type 'A' must have a '[Symbol.iterator]()' method that returns an iterator.
          await action(...args);
        } catch (ex: any) {
          throw ex;
        } finally {
          setIsLoading(false);
        }
      }
    },
  };
}

// @ts-expect-error - TS2370 - A rest parameter must be of an array type.
export function useAsyncActionHandler<A>(action: (...args: A) => unknown): {
  isLoading: boolean;
  error: Error | null | undefined;
  // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
  act: (...args: A) => Promise<void>;
} {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<Error | null | undefined>(null);

  return {
    isLoading,
    error,
    // @ts-expect-error - TS2370 - A rest parameter must be of an array type.
    act: async (...args) => {
      if (!isLoading) {
        setIsLoading(true);
        setError(null);
        try {
          // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'A'. | TS2488 - Type 'A' must have a '[Symbol.iterator]()' method that returns an iterator.
          await action(...args);
        } catch (err: any) {
          setError(err);
        } finally {
          setIsLoading(false);
        }
      }
    },
  };
}
